@if (showSearch) {
  <div class="mb-3 w-full max-w-[420px] print:hidden">
    <svz-search-field
      inputId="alert-record-modal-plan-search"
      inputTestId="alert-record-modal__input--plan-search"
      [disabled]="isLoading"
      (valueChange)="filterActionsPlans($event)"
    />
  </div>
}

@if (isLoading && !actionsPlans?.length) {
  <div class="flex flex-col gap-3 py-2">
    @for (row of [1, 2, 3]; track row) {
      <svz-skeleton height="20px" />
    }
  </div>
} @else if (!actionsPlans?.length) {
  <div
    class="mt-2 rounded-[12px] border border-[#e4e7ea] px-5 py-12 text-center"
    svcTestId="alert-record-modal__section--plans-empty"
  >
    <h3 class="m-0 mb-1.5 text-base font-bold leading-normal text-[#1c1c1c]">{{ 'Nenhum plano de ação encontrado' | transloco }}</h3>

    @if (canAddPlan) {
      <button
        type="button"
        class="mt-2.5 inline-flex h-10 items-center justify-center rounded-[8px] bg-primary px-4 text-sm leading-[normal] font-semibold text-white hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
        svcTestId="alert-record-modal__btn--new-plan-empty"
        (click)="openDialogActionPlan()"
      >
        {{ 'Novo plano de ação' | transloco }}
      </button>
    }
  </div>
} @else {
  <div class="relative">
    <table class="w-full border-collapse">
      <thead>
        <tr>
          <th
            scope="col"
            class="bg-[#F3F3F3] px-4 py-[13px] text-left text-xs leading-[normal] font-semibold uppercase tracking-[.03em] text-[#555]"
          >
            {{ 'O quê' | transloco }}
          </th>
          <th
            scope="col"
            class="bg-[#F3F3F3] px-4 py-[13px] text-left text-xs leading-[normal] font-semibold uppercase tracking-[.03em] text-[#555] max-[1023px]:hidden"
          >
            {{ 'Quem' | transloco }}
          </th>
          <th
            scope="col"
            class="bg-[#F3F3F3] px-4 py-[13px] text-left text-xs leading-[normal] font-semibold uppercase tracking-[.03em] text-[#555] max-[1023px]:hidden"
          >
            {{ 'Quando' | transloco }}
          </th>
          <th
            scope="col"
            class="bg-[#F3F3F3] px-4 py-[13px] text-left text-xs leading-[normal] font-semibold uppercase tracking-[.03em] text-[#555]"
          >
            {{ 'Status' | transloco }}
          </th>
        </tr>
      </thead>

      <tbody>
        @for (row of planRows; track row.plan.planId) {
          <tr
            class="hover:bg-[#fafafe]"
            [svcTestId]="'alert-record-modal__row--plan-' + row.plan.planId"
          >
            <td class="border-b border-[#e4e7ea] p-4 align-middle text-sm leading-5 text-[#2a2a2a]">
              <button
                type="button"
                class="block text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary"
                [svcTestId]="'alert-record-modal__btn--open-plan-' + row.plan.planId"
                (click)="openDialogActionPlan(row.plan, false)"
              >
                @if (tempId && !id) {
                  <span class="block whitespace-nowrap font-semibold text-primary">{{ ('Rascunho' | transloco).toUpperCase() }} {{ row.plan.draftNumber }}</span>
                }
                <span class="line-clamp-2 break-words">
                  {{ row.restricted ? ('Registro de acesso restrito' | transloco) : row.plan.planName }}
                </span>
              </button>
            </td>

            <td class="border-b border-[#e4e7ea] p-4 align-middle text-sm leading-5 text-[#2a2a2a] max-[1023px]:hidden">
              <span class="inline-flex max-w-full items-center gap-2">
                <svz-user-avatar
                  class="flex-none"
                  [info]="row.responsible"
                />
                <span class="truncate">{{ row.plan.senderName }}</span>
              </span>
            </td>

            <td
              class="whitespace-nowrap border-b border-[#e4e7ea] p-4 align-middle text-sm leading-5 text-[#2a2a2a] max-[1023px]:hidden"
              [svcTestId]="'alert-record-modal__text--plan-when-' + row.plan.planId"
            >
              {{ row.plan.previsionDate ? (row.plan.previsionDate | dateFormat) : row.delay }}
            </td>

            <td class="border-b border-[#e4e7ea] p-4 align-middle text-sm leading-5 text-[#2a2a2a]">
              <svz-status-badge
                variant="pill"
                [svcTestId]="'alert-record-modal__badge--plan-status-' + row.plan.planId"
                [truncate]="false"
                [badgeData]="{ description: (row.statusLabel | transloco), type: actionPlanStatusType[row.plan.statusId] }"
                [colorClass]="row.statusPillClass"
              />
            </td>
          </tr>
        }
      </tbody>
    </table>

    @if (showPagination) {
      <svz-paginate
        testIdPrefix="alert-record-modal-plans"
        [current]="pageIndex"
        [totalRegisters]="totalRegisters"
        [pageSize]="pageSize"
        [showPageSize]="false"
        (onPageChanged)="onPageChange($event)"
      />
    }

    @if (isLoading) {
      <div class="absolute inset-0 bg-white/70"></div>
    }
  </div>

  @if (canAddPlan) {
    <button
      type="button"
      class="mt-3.5 inline-flex h-10 items-center justify-center gap-2 rounded-[8px] border border-primary bg-white px-4 text-sm leading-[normal] font-semibold text-primary hover:bg-primary/5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
      svcTestId="alert-record-modal__btn--new-plan"
      (click)="openDialogActionPlan()"
    >
      <ng-icon
        name="svcPlus"
        size="20px"
        aria-hidden="true"
      />
      {{ 'Novo plano de ação' | transloco }}
    </button>
  }
}
